

















































import {
    Component,
    Vue,
    Prop,
} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import DidsInfoTable from '@/components/queue/DidsInfoTable.vue';
import { Queue } from '@/store/modules/queue/types';
import { Agent, BridgeAgent } from '@/store/modules/agent';
import idealName from '@/utils/ideal-name';
import { DidsInfoMap, DidRow } from '@/api/dids';

@Component({
    components: {
        Icon,
        DidsInfoTable,
    },
})
export default class QueueRow extends Vue {
    @Prop(String) readonly queueName!: string;

    @Prop({ type: Array, default: () => [] }) readonly dids!: string[];

    @Prop({ type: Object, default: () => ({}) }) readonly didsInfo!: DidsInfoMap;

    get rows(): DidRow[] {
        return this.dids.map((did) => ({
            did,
            medio: this.didsInfo[did]?.medio ?? null,
            producto: this.didsInfo[did]?.producto ?? null,
        }));
    }

    get queue(): Queue {
        return this.$store.getters.getQueueByName(this.queueName);
    }

    get displayName(): string {
        return this.$store.getters.queueName(this.queueName);
    }

    get activeCalls(): number {
        const agentsContainer = this.$store.state.agent?.agentsContainer || {};
        let count = 0;
        const normalizedQueueName = idealName(this.queueName);

        Object.values(agentsContainer).forEach((agent: unknown) => {
            const a = agent as Agent;
            if (a.queueCalls && a.queueCalls.size > 0) {
                a.queueCalls.forEach((call: BridgeAgent) => {
                    if (idealName(call.queue) === normalizedQueueName) {
                        count += 1;
                    }
                });
            }
        });

        return count;
    }

    get waitingCalls(): number {
        return this.$store.getters.queueMembersCount(this.queueName) || 0;
    }
}
